import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/slide_bg_01.png'
import _imports_1 from '../assets/img/wap_slides_bg_01.png'
import _imports_2 from '../assets/img/slide_bg_02.png'
import _imports_3 from '../assets/img/wap_slides_bg_02.png'
import _imports_4 from '../assets/img/slide_bg_03.png'
import _imports_5 from '../assets/img/wap_slides_bg_03.png'
import _imports_6 from '../assets/img/slide_bg_04.png'
import _imports_7 from '../assets/img/wap_slides_bg_04.png'
import _imports_8 from '../assets/img/slide_bg_05.png'
import _imports_9 from '../assets/img/wap_slides_bg_05.png'
import _imports_10 from '../assets/img/show_btn.png'
import _imports_11 from '../assets/img/hiden_btn.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"bg\"><div class=\"bg-01\"><img class=\"pc-show\" src=\"" + _imports_0 + "\" alt=\"\"><img class=\"wap-show\" src=\"" + _imports_1 + "\" alt=\"\"></div><div class=\"bg-02\"><img class=\"pc-show\" src=\"" + _imports_2 + "\" alt=\"\"><img class=\"wap-show\" src=\"" + _imports_3 + "\" alt=\"\"></div><div class=\"bg-03\"><img class=\"pc-show\" src=\"" + _imports_4 + "\" alt=\"\"><img class=\"wap-show\" src=\"" + _imports_5 + "\" alt=\"\"></div><div class=\"bg-04\"><img class=\"pc-show\" src=\"" + _imports_6 + "\" alt=\"\"><img class=\"wap-show\" src=\"" + _imports_7 + "\" alt=\"\"></div><div class=\"bg-05\"><img class=\"pc-show\" src=\"" + _imports_8 + "\" alt=\"\"><img class=\"wap-show\" src=\"" + _imports_9 + "\" alt=\"\"></div></div>", 1)
const _hoisted_2 = { class: "slide-inner" }
const _hoisted_3 = { class: "swiper" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  src: _imports_10,
  alt: ""
}
const _hoisted_8 = {
  src: _imports_11,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["slide-wrapper", [_ctx.isShow ? 'show' : 'hide']])
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["swiper-slide", ['swiper-slide-' + index, _ctx.startAni && 'ani']]),
                onClick: ($event: any) => (_ctx.goSpeaker(index)),
                key: index
              }, [
                _createElementVNode("img", {
                  src: item.slideImg,
                  alt: ""
                }, null, 8, _hoisted_6)
              ], 10, _hoisted_5))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "btn prev-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }),
      _createElementVNode("div", {
        class: "btn next-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      })
    ], 2),
    _createElementVNode("div", {
      class: "toggle-btn",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
        [_vShow, !_ctx.isShow]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
        [_vShow, _ctx.isShow]
      ])
    ])
  ], 64))
}